export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-grid'
    },
    {
      title: true,
      name: 'Master',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'User Accounts',
      url: '/user-accounts',
      icon: 'icon-list',
      children: [
        {
          name: 'Employee',
          url: '/user-accounts/employee',
          icon: 'icon-user'
        },
        {
          name: 'Partner',
          url: '/user-accounts/partner',
          icon: 'icon-user'
        }
      ]
    },
    {
      name: 'User Profiles',
      url: '/user-profiles',
      icon: 'icon-list'
    },
    {
      name: 'User Roles',
      url: '/user-roles',
      icon: 'icon-list'
    },
    {
      name: 'User Services',
      url: '/user-services',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Logs',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'User States',
      url: '/user-states',
      icon: 'icon-list'
    }
  ]
}
